import angular from 'angular';
import cqpCpaSidebar from './cqpCpaSidebar';
import './style.scss';

export default angular
  .module('components.cqpCpaSidebar', [])
  .component('cqpCpaSidebar', cqpCpaSidebar).name;
